import React from 'react'
import HighlightText from '@consteed/frontend/components/pageDesigner/RTE/HighlightText'
import {generalUrlBuilder} from '@consteed/overrides/utils/url'
import Link from '@consteed/overrides/components/link'
import {Heading} from '@salesforce/retail-react-app/app/components/shared/ui'
import {domToReact} from 'html-react-parser'

export const hrefToLinkObject = (href = '') => {
    const productUrlRegex = /\/product\/(?<productid>.+)\.html/gi
    const categoryUrlRegex = /\/category\/(?<catid>[^/\s?]+)$/gi
    const pagesUrlRegex = /\/lp\/(?<pageid>.+)\.html/gi

    const productMatches = productUrlRegex.exec(href)
    let matchFound = false
    let linkObject = {
        linkType: 'External',
        href: href
    }
    if (productMatches?.groups?.productid) {
        linkObject.linkType = 'Product'
        linkObject.id = productMatches?.groups?.productid
        matchFound = true
    }
    if (!matchFound) {
        const pageMatches = pagesUrlRegex.exec(href)
        if (pageMatches?.groups?.pageid) {
            linkObject.linkType = 'Page'
            linkObject.id = pageMatches?.groups?.pageid
            matchFound = true
        }
    }
    if (!matchFound) {
        const categoryMatches = categoryUrlRegex.exec(href)
        if (categoryMatches?.groups?.catid) {
            linkObject.linkType = 'Category'
            linkObject.id = categoryMatches?.groups?.catid
            matchFound = true
        }
    }
    if (!matchFound) {
        switch (href) {
            case 'blog':
                linkObject.linkType = 'Blog'
                break
            case 'contact':
                linkObject.linkType = 'ContactUs'
                break
            default:
            // ignore
        }
    }
    return linkObject
}

export const convertSfccHrefToPwaHref = (href = '') => {
    const linkObject = hrefToLinkObject(href)
    return generalUrlBuilder(linkObject)
}

export const sfccAnchorToLink = (element, parserOptions = {}) => {
    const {href = ''} = element.attribs
    const linkObject = hrefToLinkObject(href)

    return (
        <Link to={generalUrlBuilder(linkObject)} color="yellow.400" textDecoration={'underline'}>
            {domToReact(element.children, parserOptions)}
        </Link>
    )
}

export const elementToHighlightText = (element, parserOptions = {}) => {
    return <HighlightText>{domToReact(element.children, parserOptions)}</HighlightText>
}

export const elementToNormalWeightHighlightText = (element, parserOptions = {}) => {
    return (
        <HighlightText fontWeight="500">
            {domToReact(element.children, parserOptions)}
        </HighlightText>
    )
}

export const handleHeadlineTag = (element, parserOptions = {}) => {
    let textStyle
    let headlineTag

    switch (element.name) {
        case 'h1':
            textStyle = parserOptions.textStyles || 'book6Xlarge'
            headlineTag = 'h1'
            break
        case 'h2':
            textStyle = parserOptions.textStyles || 'book4Xlarge'
            headlineTag = 'h2'
            break
        case 'h3':
            textStyle = parserOptions.textStyles || 'book2Xlarge'
            headlineTag = 'h3'
            break
        default:
            textStyle = parserOptions.textStyles || 'bookLarge'
            headlineTag = 'h4'
            break
    }
    return (
        <Heading as={headlineTag} fontWeight={'inherit'} size={textStyle}>
            {domToReact(element.children, parserOptions)}
        </Heading>
    )
}

export const simpleConsteedTagConfig = {
    handleLinkTag: sfccAnchorToLink,
    handleEmTag: elementToHighlightText,
    handleHeadlineTag: handleHeadlineTag
}

export const imageTextTileTagConfig = {
    handleLinkTag: sfccAnchorToLink,
    handleEmTag: elementToNormalWeightHighlightText,
    handleHeadlineTag: handleHeadlineTag
}
